export const SENTRY_DSN_WEB_DEV =
  'https://6b9e3611f3d9490b8c27e323a43dba7e@o273287.ingest.sentry.io/1796642';
export const SENTRY_DSN_WEB_PROD =
  'https://c049cba09d6348798ec2f0b3734648ac@o273287.ingest.sentry.io/5188789';
/**
 * PERIODIC CHECK FOR UPDATE EVERY 10 MIN
 */
export const PERIODIC_UPDATE_CHECK_INTERVAL = 600000;
/**
 * DAILY CHECK FOR UPDATE EVERY 24 HOURS
 */
export const DAILY_UPDATE_CHECK_INTERVAL = 86400000;

export const S3_BASE_URL_PROD = 'https://nuacom-app.s3.eu-west-1.amazonaws.com';
export const S3_BASE_URL_DEV =
  'https://nuacom-app-test.s3.eu-west-1.amazonaws.com';

export const TWO_FACTOR_CODE_TIMEOUT = 120;
export const VIDEO_WS_SERVER = 'https://wss-video.nuacom.net';
export const WEB_URL_DEV = 'https://d1gaikb7mx9zak.cloudfront.net';

// VOICE SERVER CONFIG
export const SERVER_URL = 'webrtc-gw.nuacom.net';
export const DEV_SERVER_URL = 'dev-webrtc-gw.nuacom.net';
export const DEFAULT_RING_TIMEOUT = 120;
export const EXPIRES = 60; // DEFAULT SIP EXPIRES TIMEOUT
export const RETRY_TIMEOUT = 5; // TIME INTERVAL FOR TRANSPORT RECONNECTION IN SECONDS.
// Determines when a re-REGISTER request is sent. The value should be specified as a percentage of the expiration time (between 50 and 99).
export const REFRESH_FREQUENCY = 82;
export const MIXPANEL_PROJECT_TOKEN = '09952668ecb3e9d7ccbb9f3f819d4872';
//  route requests to Mixpanel's EU server
export const MIXPANEL_PROJECT_API_HOST = 'https://api-eu.mixpanel.com';
export const AGENT_STATUS_URL = 'wss-agents.nuacom.net';
export const PUBLIC_API_BASE_URL = 'https://api.api-nuacom.com';

export const UPDATER_CONFIG = {
  PROD: {
    UPDATE_CHECKER_URL: `${S3_BASE_URL_PROD}/app2/updater/updater.json`,
  },
  DEV: {
    UPDATE_CHECKER_URL: `${S3_BASE_URL_DEV}/app2/updater/updater.json`,
  },
  RC: {
    UPDATE_CHECKER_URL: `${S3_BASE_URL_DEV}/release-candidate/app/updater.json`,
  },
  LOCALHOST: {
    UPDATE_CHECKER_URL: `https://localhost:3000/updater/updater.json`,
  },
};
